// extracted by mini-css-extract-plugin
module.exports = {"lia-edit-btn":"FeaturedPlacesWidget_lia-edit-btn__5DHWQ"};